import { Warning } from "@phosphor-icons/react";

const MESSAGE =
  "Notice: Our primary payment processor is temporarily down — please use an alternative payment method (Zelle, Cash App, Google Pay or Apple Pay) at checkout.";

export default function AnnouncementBanner() {
  return (
    <div
      data-testid="announcement-banner"
      className="w-full overflow-hidden bg-[#7A1F1F] border-b border-red-300/30 relative z-[4]"
    >
      <div className="marquee-track py-2">
        {[0, 1].map((n) => (
          <span
            key={n}
            aria-hidden={n === 1}
            className="label-mono text-white/90 text-[0.65rem] inline-flex items-center gap-2 px-8"
          >
            <Warning size={13} weight="fill" className="text-white" />
            {MESSAGE}
          </span>
        ))}
      </div>
    </div>
  );
}
